import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Base, PaymentTypes, UserTypes } from "../../../_models";
import { FormGroup } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import * as _ from "lodash";
import { DataService } from "../../../_services/data.service";
import { AlertService } from "../../../_services/alert.service";

@Component({
  moduleId: module.id,
  selector: "singlereceipt",
  templateUrl: "single-receipt.component.html",
  styleUrls: ["./single-receipt.component.css"],
})
export class SingleReceiptComponent {
  @Input() base: Base;
  @Input() event: any;
  @Output() actionCompleted?: EventEmitter<number> = new EventEmitter<number>();

  UserTypesEnum = UserTypes;
  PaymentTypesEnum = PaymentTypes;
  loading: boolean = false;
  successMessage: string;
  errorMessage: string;
  formGroup: FormGroup;
  modalReference: any;

  constructor(
    public dataService: DataService,
    private alertService: AlertService,
    private modalService: NgbModal
  ) {}

  cancelItem(child) {
    if (!this.loading) {
      this.loading = true;
    }
  }

  openReceipt(childData) {
    if (childData && childData.receiptUrl)
      window.open(childData.receiptUrl, "_blank");
  }

  getItemForRefund(child) {
    let v = _.merge({}, this.event, child);

    v.isCash = true;
    v.id = v.itemId;
    // 		delete v.children;

    return v;
  }

  refundHappenedEvent() {
    console.info("refundHappenedEvent");
    this.actionCompleted.emit(this.event.adminUser);
  }

  onActionCompleted() {
    console.info("actionCompleted");
    // if (this.actionCompleted) {
    //   this.actionCompleted.emit();
    // }
  }

  // getChildren() {
  //   if (this.event && this.event.children && this.event.children.length) {
  //     return this.event.children.length > 3 ? this.event.children.slice(0, 3) : this.event.children;
  //   }
  //   return;
  // }
}



// WEBPACK FOOTER //
// ./src/app/admin/teshlumon/open-receipts/single-receipt.component.ts